// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
}

.radio-container.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.radio-input {
  display: none;
}

.radio-custom {
  width: 16px;
  height: 16px;
  border: 1px solid var(--color-gray);
  border-radius: 50%;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background-color: var(--color-white);
}

.radio-custom.checked {
  border-color: var(--color-primary-green);
}

.radio-custom.checked::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--color-primary-green);
}

.radio-custom.disabled {
  background-color: var(--color-light-gray);
  border-color: var(--color-gray);
  cursor: not-allowed;
}

.radio-custom.disabled.checked {
  border-color: var(--color-gray);
}

.radio-custom.disabled.checked::after {
  background-color: var(--color-gray);
}

.radio-label {
  color: var(--color-black);
  flex: 1;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .radio-custom {
    
  }
  
  .radio-custom.checked::after {
    left: 3px;
    top: 3px;
    width: 8px;
    height: 8px;
  }
  
  .radio-container {
    gap: 10px;
  }
}

/* Radio Group Styles */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radio-group .radio-container {
  margin-bottom: 0;
} `, "",{"version":3,"sources":["webpack://./src/components/Radio/Radio.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,OAAO;AACT;;AAEA,6BAA6B;AAC7B;EACE;;EAEA;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".radio-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n.radio-container.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.radio-input {\n  display: none;\n}\n\n.radio-custom {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--color-gray);\n  border-radius: 50%;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  background-color: var(--color-white);\n}\n\n.radio-custom.checked {\n  border-color: var(--color-primary-green);\n}\n\n.radio-custom.checked::after {\n  content: \"\";\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--color-primary-green);\n}\n\n.radio-custom.disabled {\n  background-color: var(--color-light-gray);\n  border-color: var(--color-gray);\n  cursor: not-allowed;\n}\n\n.radio-custom.disabled.checked {\n  border-color: var(--color-gray);\n}\n\n.radio-custom.disabled.checked::after {\n  background-color: var(--color-gray);\n}\n\n.radio-label {\n  color: var(--color-black);\n  flex: 1;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .radio-custom {\n    \n  }\n  \n  .radio-custom.checked::after {\n    left: 3px;\n    top: 3px;\n    width: 8px;\n    height: 8px;\n  }\n  \n  .radio-container {\n    gap: 10px;\n  }\n}\n\n/* Radio Group Styles */\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.radio-group .radio-container {\n  margin-bottom: 0;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
